<template>
  <div>
    <v-card tile>
    <v-toolbar card style="background: #1a222c !important;">
      <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">info</v-icon>&nbsp;&nbsp;{{$t('Settings.helpCenter.header')}} </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    </v-card>
      <br>
      <br>
      <div  style="text-align: center;">
        <img src="/static/img/onechat/map.png" width="400">
      </div>
        <br>
        <div style="padding: 3vw; padding-left: 10vw; padding-right:10vw;">
        <b style="font-size: 18px;" class="CSChatThai">{{$t('Settings.helpCenter.company')}}</b> <br>
        <b style="font-size: 15px;" class="CSChatThai">{{$t('Settings.helpCenter.address')}}</b><br><br>
        <b style="font-size: 15px;">{{$t('Settings.helpCenter.email')}}: <a href="mailto:onechat@one.th" class="">onechat@one.th</a></b>
        </div>
  </div>
</template>
<script type="text/javascript">
export default {
  data: () => ({
  }),
  methods: {
  }
}
</script>
<style type="text/css" scoped>
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
a:link {
    text-decoration: none;
    color: black !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #1e88e5 !important;
    text-decoration: none;
}

a:active {
    color: black !important;
    text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/chat/settings/Contact.vue